/* eslint-disable import/no-cycle */
import Const from '../const';
import {
  updateUserAPI, validateEmailAPI, getUserAPI, logOutAPI
} from '../../utils/api';
import { log, LOG_LEVELS } from '../../../common/config/app_logger';
import { errorText, errorTypes } from '../application/application_action';
import { emailIsValid } from '../../../common/config/utils';
import {
  editPendingWebOrders, saveToOrder, clearOrderKey, orderKeys
} from '../order/order_action';
import { getPaymentConfigsAction } from '../payments/payments_action';
import { trackEvent } from '../../utils/analytics/analytics';

export const userLoading = () => ({
  type: Const.user.loading
});

const userError = (error) => ({
  type: Const.user.error,
  error
});

export const userLoaded = (user) => ({
  type: Const.user.loaded,
  user
});

export const emailValidated = (email, needCheckUserChangeEmailAddress) => ({
  type: Const.user.emailValidated,
  email,
  needCheckUserChangeEmailAddress
});

const emailValidationError = (error, email) => ({
  type: Const.user.emailValidationError,
  error,
  email
});

const emailError = (error) => ({
  type: Const.user.emailError,
  error
});

const emailValidationErrorClear = () => ({
  type: Const.user.emailValidationErrorClear
});

export const emailErrorAction = (error) => (dispatch) => {
  dispatch(emailError(error));
};

export const emailValidationErrorClearAction = () => (dispatch) => {
  dispatch(emailValidationErrorClear());
};

export const saveUser = (props) => (dispatch) => {
  const { userId, userMixpanelAliasCreated } = props;
  if (userId === undefined || userMixpanelAliasCreated === undefined) return;
  window.currentUserId = userId;
  dispatch(userLoaded(props));
};

export const updateUser = (payload) => (dispatch) => {
  dispatch(userLoading());
  log(LOG_LEVELS.INFO, 'User', 'Updating user data', payload);
  updateUserAPI(payload).then((responce) => {
    const { user: { id, mixpanelAliasCreated, nickname } } = responce;
    dispatch(saveUser({ userId: id, userMixpanelAliasCreated: mixpanelAliasCreated, nickname }));
  }).catch((error) => {
    dispatch(userError(error));
  });
};

const updateUserEmail = (email) => (dispatch, getState) => {
  dispatch(editPendingWebOrders({ props:{ email } })).then(() => {
    const { needRefreshPaymentConfig } = getState().order.pendingWebOrder;
    if (needRefreshPaymentConfig) {
      dispatch(getPaymentConfigsAction());
      dispatch(clearOrderKey(orderKeys.needRefreshPaymentConfig));
    }
  }).catch((error) => {
    const saveToOrderProps = { additionalParams: { email } };
    dispatch(saveToOrder(saveToOrderProps));
    dispatch(userError(error));
  });
};
export const validateEmail = ({
  t, email, needCheckUserChangeEmailAddress, screen
}) => (dispatch, getState) => {
  const { emailDetails } = getState().user;
  if (email === emailDetails.email) return;
  if (!emailIsValid(email)) {
    dispatch(emailValidationError({ [errorTypes.email] : t('error.please_enter_a_valid_email_address') }));
    return;
  }
  dispatch(userLoading());
  validateEmailAPI(email).then(() => {
    dispatch(emailValidated(email, needCheckUserChangeEmailAddress));
    dispatch(updateUserEmail(email));
  }).catch((error) => {
    if (error.email && error.email.includes(errorText.emailAlreadyRegistered)) {
      trackEvent('email validation failed', { screen });
    }
    dispatch(emailValidationError(error, email));
  });
};

export const getUser = () => (dispatch) => {
  dispatch(userLoading());
  getUserAPI()
    .then(responce => {
      const { user } = responce;
      log(LOG_LEVELS.INFO, 'User', 'Retrieved user data', user);
      const { id, mixpanelAliasCreated, ...rest } = user;
      dispatch(userLoaded({ userId: id, userMixpanelAliasCreated: mixpanelAliasCreated, ...rest }));
    })
    .catch(error => {
      log(LOG_LEVELS.ERROR, 'User', 'Failed to get user data', error);
      dispatch(userError(error));
    });
};

export const logout = () => (/* dispatch */) => {
  logOutAPI()
    .then((/* response */) =>  {
      window.location.href = window.location.origin;
    })
    .catch((error) => log(LOG_LEVELS.ERROR, 'Auth', 'Logout failed', error));
};

export const userMPIdentify = () => (dispatch) => {
  dispatch({ type: Const.user.MPIdentify });
};
